import { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Colors } from "../../utils/colors";
import { Fonts } from "../../utils/fonts";
import Loader from "../../components/Loader";
import ShareEmailModal from "../../components/ShareEmailModal";
import ErrorMessage from "../../components/ErrorMessage";
import type { IPublicationsItem } from "../../services/types";

import backIcon from "../../assets/backIcon.png";
import emailIcon from "../../assets/email.png";
import { TintIcon } from "../../components/TintIcon";
import { FontSizes } from "../../assets/fonts/fontSizes";

type LocationState = { publication?: IPublicationsItem };

export default function DocumentsWebViewScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = (location.state || {}) as LocationState;

  const publication = state.publication;

  const [modalOpen, setModalOpen] = useState(false);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  const url = useMemo(() => publication?.documentUrl ?? "", [publication]);

  if (!publication) return <ErrorMessage />;

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button
          type="button"
          style={styles.buttonContainer}
          onClick={() => navigate(-1)}
        >
          <TintIcon src={backIcon} size={20} color={Colors.White} />
          <span style={styles.text}>Back</span>
        </button>

        <button
          type="button"
          style={styles.buttonContainer}
          onClick={() => setModalOpen(true)}
        >
          <TintIcon src={emailIcon} size={20} color={Colors.White} />
          <span style={styles.text}>Share as an email</span>
        </button>
      </div>

      <div style={styles.viewerWrap}>
        {!iframeLoaded ? <Loader /> : null}

        <iframe
          title={publication.name}
          src={url}
          style={{
            ...styles.iframe,
            visibility: iframeLoaded ? "visible" : "hidden",
          }}
          onLoad={() => setIframeLoaded(true)}
        />
      </div>

      <ShareEmailModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        publication={publication}
      />
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: { padding: 20 },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingBottom: 10,
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "rgba(255,255,255,0.10)",
    height: 40,
    padding: "0 15px",
    borderRadius: 20,
    border: "none",
    cursor: "pointer",
  },
  icon: { height: 20, width: 20, objectFit: "contain" },
  text: {
    fontSize: FontSizes.xs,
    fontWeight: Fonts.Light,
    color: Colors.White,
    paddingLeft: 5,
    fontFamily: "Inter",
  },
  viewerWrap: {
    position: "relative",
    width: "100%",
    height: "calc(100vh - 140px)",
  },
  iframe: {
    width: "100%",
    height: "100%",
    border: "none",
    background: "transparent",
  },
};
